import React from 'react';
import { FEATURE_FLAGS } from 'Settings';

import styles from './StudentActivity.scss';
import WithClassStudents from 'Containers/WithClassStudents';
import UsersListHeader from 'Components/UsersListHeader';
import StudentActivitySummaries from 'Components/StudentActivitySummaries';
import StudentActivityDetails from 'Components/StudentActivityDetails';

const StudentActivity = ({ students }) => {
  if (!FEATURE_FLAGS.studentActivity) return null;
  return (
    <div className="StudentActivity">
      <UsersListHeader type="activity" title="Student Activity This Week" />
      <div className="StudentActivity__container">
        <StudentActivitySummaries students={students} />
        <StudentActivityDetails />
      </div>
    </div>
  );
};

export default WithClassStudents(StudentActivity);
